import { useContext } from 'react'
import { MergeAccountsContext } from './MergeAccountsContext'

export function useMergeAccounts() {
  const context = useContext(MergeAccountsContext)

  if (!context) {
    throw new Error('useMergeAccounts must be used within a MergeAccountsProvider')
  }

  return context
}
